// @ts-nocheck
/**
 * Used to generate localization keys dynamically.
 * MessageKeysMock should be applied as a global
 * variable to hasten writing message id.
 * Alternatively, MessageKeysMock can be imported
 * and used to write message id.
 *
 * Example:
 *  globalMock.parent.child.child => [parent, child, child]
 *  Transforms path to array.
 *
 */

export const createMessageKeys = path =>
  new Proxy(path, {
    get(target, prop) {
      if (target[prop]) {
        return target[prop];
      }
      return createMessageKeys([...path, prop]);
    },
  });

export const MessageKeysMock = new Proxy(
  {},
  {
    get(target, prop) {
      return createMessageKeys([prop]);
    },
  },
);
